module.exports = __webpack_public_path__ + "static/media/eu_verdadeiro_5.36f2531b.jpg";